define.alias("shared/components/shared/ember-drop-multi-select", "media/components/shared/ember-drop-multi-select");